module.exports = __webpack_public_path__ + "img/undraw_Business_plan_re_0v81.cc734e3f.svg";